import { DownloadOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React, { FC } from 'react';
import { CSVLink } from 'react-csv';
import './CsvReportDownload.less';

interface CsvReportDownloadInterface {
  csvData: Array<any>;
  fileName: string;
}

const CsvReportDownload: FC<CsvReportDownloadInterface> = ({ csvData, fileName }) => {
  return (
    <Tooltip placement="top" title={'Download csv report'}>
      <Button disabled={!csvData.length} className="csv-btn" icon={<DownloadOutlined />}>
        <CSVLink filename={`${fileName}.csv`} data={csvData}>
          Download
        </CSVLink>
      </Button>
    </Tooltip>
  );
};

export default CsvReportDownload;
